function updateReviewsLinks() {
  document.querySelectorAll('.product-info__block-item[data-block-type="@app"] .jdgm-all-reviews-text a').forEach(function (link) {
    link.setAttribute('href', '/pages/reviews');
    link.setAttribute('aria-label', 'Read customer reviews');
  });
}

document.addEventListener('click', function (event) {
  const megaMenuSummary = event.target.closest('mega-menu-disclosure .header__menu-disclosure > summary[data-follow-link]');

  if (!megaMenuSummary) {
    return;
  }

  const destination = megaMenuSummary.getAttribute('data-follow-link');

  if (!destination || destination === '#') {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(destination);
}, true);

if (window.location.pathname.includes('/pages/reviews')) {
  document.documentElement.classList.add('reviews-page-loading');
  window.setTimeout(function () {
    document.documentElement.classList.add('reviews-page-ready');
  }, 5000);
}

function updateReviewsPageState() {
  const reviewsWidget = document.querySelector('.jm-review-widget');

  if (!reviewsWidget || !window.location.pathname.includes('/pages/reviews') || document.documentElement.classList.contains('reviews-page-ready')) {
    return;
  }

  document.documentElement.classList.add('reviews-page-loading');

  const hasHeader = reviewsWidget.querySelector('.jm-review-widget__header');
  const hasBody = reviewsWidget.querySelector('.jm-review-widget__body');
  const hasReviews = reviewsWidget.querySelector('.jm-review, .jm-review-card, [class*="review-list"]');

  if (hasHeader && hasBody && hasReviews) {
    window.clearTimeout(window.graniteReviewsReadyTimer);
    window.graniteReviewsReadyTimer = window.setTimeout(function () {
      document.documentElement.classList.add('reviews-page-ready');
    }, 350);
  }
}

document.addEventListener('click', function (event) {
  const reviewsLink = event.target.closest('.product-info__block-item[data-block-type="@app"] .jdgm-all-reviews-text a');

  if (reviewsLink) {
    event.preventDefault();
    window.location.assign('/pages/reviews');
  }
}, true);

document.addEventListener('DOMContentLoaded', updateReviewsLinks);
document.addEventListener('DOMContentLoaded', updateReviewsPageState);
updateReviewsLinks();
updateReviewsPageState();

new MutationObserver(function () {
  updateReviewsLinks();
  updateReviewsPageState();
}).observe(document.documentElement, {
  childList: true,
  subtree: true
});

(function setupFutureBlinkCandyRackBar() {
  const barId = '11188ada-07ce-4a27-b506-e24427ec2a80';
  const barSelector = `[futureblink-shipping-type="cart_drawer"][id="${barId}"]`;
  const shippingBar = document.querySelector(`${barSelector}[data-granite-hoppy-source]`);
  let frameId = null;

  if (!shippingBar) {
    return;
  }

  function mountShippingBar() {
    frameId = null;

    const candyRackDrawer = document.getElementById('candyrack-slider-cart');

    if (!candyRackDrawer) {
      return;
    }

    const candyRackPlaceholder = Array.from(
      candyRackDrawer.querySelectorAll(barSelector)
    ).find(function (element) {
      return element !== shippingBar;
    });

    if (candyRackPlaceholder) {
      candyRackPlaceholder.replaceWith(shippingBar);
    }
  }

  function scheduleShippingBarMount() {
    if (frameId !== null) {
      return;
    }

    frameId = window.requestAnimationFrame(mountShippingBar);
  }

  function startShippingBarObserver() {
    scheduleShippingBarMount();

    new MutationObserver(scheduleShippingBarMount).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startShippingBarObserver, { once: true });
  } else {
    startShippingBarObserver();
  }
})();

(function setupVipCollectionMembershipButton() {
  const vipCollectionPath = '/collections/vip';
  const currentPath = window.location.pathname.replace(/\/$/, '').toLowerCase();

  if (currentPath !== vipCollectionPath) {
    return;
  }

  const buttonLabel = 'become a vip member';

  function markMembershipButton() {
    const candidates = document.querySelectorAll('a, button, [role="link"]');

    for (const candidate of candidates) {
      if ((candidate.textContent || '').trim().toLowerCase() === buttonLabel) {
        candidate.classList.add('vip-collection__membership-button');
      }
    }
  }

  function startVipCollectionButtonObserver() {
    markMembershipButton();

    new MutationObserver(markMembershipButton).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startVipCollectionButtonObserver, { once: true });
  } else {
    startVipCollectionButtonObserver();
  }
})();

(function setupProductDiscountPriceAndQuantityTiers() {
  function formatWithDelimiters(number, precision, thousands, decimal) {
    const value = (number / 100).toFixed(precision);
    const parts = value.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    return parts[1] ? `${dollars}${decimal}${parts[1]}` : dollars;
  }

  function formatMoney(cents) {
    const settings = window.themeVariables?.settings || {};
    const format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    const template = format || '${{amount}}';
    const match = template.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!match) {
      return `$${formatWithDelimiters(cents, 2, ',', '.')}`;
    }

    let value;

    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    const wrapper = document.createElement('span');
    wrapper.innerHTML = template.replace(match[0], value);
    return wrapper.textContent;
  }

  function findByFormId(selector, formId) {
    return Array.from(document.querySelectorAll(selector)).find((element) => element.dataset.formId === formId);
  }

  function getQuantity(form) {
    const quantityInput = form?.elements.namedItem('quantity');
    return Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
  }

  function getTier(quantity) {
    if (quantity >= 3) {
      return 3;
    }

    return quantity === 2 ? 2 : 1;
  }

  function updateTierIndicator(formId, tier) {
    const indicator = findByFormId('[data-pdp-quantity-discount]', formId);

    if (!indicator) {
      return;
    }

    indicator.querySelectorAll('[data-quantity-tier]').forEach(function (tierElement) {
      const isActive = Number(tierElement.dataset.quantityTier) === tier;
      tierElement.classList.toggle('is-active', isActive);
      tierElement.setAttribute('aria-pressed', String(isActive));
    });
  }

  function updatePrice(formId) {
    const form = document.getElementById(formId);
    const priceContainer = findByFormId('[data-pdp-discount-price]', formId);

    if (!form || !priceContainer) {
      return;
    }

    updateTierIndicator(formId, getTier(getQuantity(form)));

    const variantInput = form.elements.namedItem('id');
    const variantsElement = priceContainer.querySelector('[data-pdp-variants]');

    if (!variantInput || !variantsElement) {
      return;
    }

    let variants;

    try {
      variants = JSON.parse(variantsElement.textContent || '[]');
    } catch (error) {
      return;
    }

    const variantId = Number.parseInt(variantInput.value, 10);
    const variant = variants.find((item) => Number(item.id) === variantId);

    if (!variant || typeof variant.price !== 'number') {
      return;
    }

    const discountPercent = Number(priceContainer.dataset.discountPercent || 0);
    const discountedPrice = Math.round(variant.price * (100 - discountPercent) / 100);
    const comparePrice = priceContainer.querySelector('[data-compare-price]');
    const salePrice = priceContainer.querySelector('[data-sale-price]');

    if (comparePrice) {
      comparePrice.textContent = formatMoney(variant.price);
      comparePrice.hidden = false;
    }

    if (salePrice) {
      salePrice.textContent = formatMoney(discountedPrice);
    }
  }

  function updateAllPrices() {
    document.querySelectorAll('[data-pdp-discount-price][data-form-id]').forEach(function (priceContainer) {
      updatePrice(priceContainer.dataset.formId);
    });
  }

  function handleQuantityInteraction(event) {
    if (!event.target.matches('.product-info input[name="quantity"]')) {
      return;
    }

    const formId = event.target.getAttribute('form') || event.target.form?.id;
    const form = formId ? document.getElementById(formId) : null;

    if (!formId || !form || !findByFormId('[data-pdp-quantity-discount]', formId)) {
      return;
    }

    window.requestAnimationFrame(function () {
      updateTierIndicator(formId, getTier(getQuantity(form)));
    });
  }

  document.addEventListener('input', handleQuantityInteraction);
  document.addEventListener('change', handleQuantityInteraction);

  document.addEventListener('click', function (event) {
    const tierButton = event.target.closest('[data-pdp-quantity-discount] [data-quantity-tier]');

    if (!tierButton) {
      return;
    }

    const indicator = tierButton.closest('[data-pdp-quantity-discount]');
    const formId = indicator?.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const quantityInput = form?.elements.namedItem('quantity');

    if (!formId || !quantityInput) {
      return;
    }

    const tier = Number(tierButton.dataset.quantityTier);
    const currentQuantity = getQuantity(form);
    const requestedQuantity = tier === 3 ? Math.max(3, currentQuantity) : tier;
    const minimum = Number.parseInt(quantityInput.min || '1', 10) || 1;
    const maximum = Number.parseInt(quantityInput.max || '', 10);
    let nextQuantity = Math.max(minimum, requestedQuantity);

    if (Number.isFinite(maximum)) {
      nextQuantity = Math.min(maximum, nextQuantity);
    }

    if (Number(quantityInput.value) === nextQuantity) {
      updateTierIndicator(formId, getTier(nextQuantity));
      return;
    }

    quantityInput.value = nextQuantity;
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('variant:change', function (event) {
    const formId = event.detail?.formId;

    if (!formId || !findByFormId('[data-pdp-discount-price]', formId)) {
      return;
    }

    window.requestAnimationFrame(function () {
      updatePrice(formId);
    });
  });

  document.addEventListener('shopify:section:load', updateAllPrices);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllPrices, { once: true });
  } else {
    updateAllPrices();
  }
})();

(function setupVipMembershipRenewalLabel() {
  const markerSelector = '[data-vip-membership-summary]';
  const freeTrialPattern = /\b(?:first\s+month\s+(?:is\s+)?free|free\s+trial)\b[^)\n]*/gi;
  const zeroRenewalPattern = /(?:[$£€]\s*|[A-Z]{3}\s*)?0(?:[.,]00)?\s*\/\s*renewal/gi;
  let frameId = null;

  function updateRenewalLabel() {
    frameId = null;

    const marker = document.querySelector(markerSelector);

    if (!marker) {
      return;
    }

    const renewalLabel = marker.dataset.vipRenewalLabel;

    if (!renewalLabel) {
      return;
    }

    /* Appstle splits the zero price and "/renewal" across nested elements in
       its select/card labels. Replace the complete label at its container. */
    document.querySelectorAll('.appstle_single_option_text, .appstle_select option').forEach(function (label) {
      const currentLabel = label.textContent || '';
      const updatedLabel = currentLabel
        .replace(zeroRenewalPattern, renewalLabel)
        .replace(freeTrialPattern, renewalLabel);
      zeroRenewalPattern.lastIndex = 0;
      freeTrialPattern.lastIndex = 0;

      if (updatedLabel !== currentLabel) {
        label.textContent = updatedLabel;
      }
    });

    /* Fall back to normal text nodes for other Appstle widget layouts. */
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let textNode;

    while ((textNode = walker.nextNode())) {
      const parentTag = textNode.parentElement?.tagName;

      if (parentTag === 'SCRIPT' || parentTag === 'STYLE' || parentTag === 'NOSCRIPT') {
        continue;
      }

      const currentText = textNode.nodeValue || '';
      const updatedText = currentText
        .replace(zeroRenewalPattern, renewalLabel)
        .replace(freeTrialPattern, renewalLabel);
      zeroRenewalPattern.lastIndex = 0;
      freeTrialPattern.lastIndex = 0;

      if (updatedText !== currentText) {
        textNode.nodeValue = updatedText;
      }
    }
  }

  function scheduleRenewalLabelUpdate() {
    if (frameId !== null) {
      return;
    }

    frameId = window.requestAnimationFrame(updateRenewalLabel);
  }

  function startVipMembershipObserver() {
    if (!document.querySelector(markerSelector)) {
      return;
    }

    scheduleRenewalLabelUpdate();

    new MutationObserver(scheduleRenewalLabelUpdate).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  document.addEventListener('shopify:section:load', scheduleRenewalLabelUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startVipMembershipObserver, { once: true });
  } else {
    startVipMembershipObserver();
  }
})();

(function setupVipPurchaseRestrictionPersistence() {
  const vipProductFormSelector = 'product-form[data-granite-vip-product]';
  const blockerSelector = '.appstle_membership_blocker_wrapper';
  const restrictedForms = new WeakMap();

  function captureRestriction(productForm) {
    const blocker = productForm.querySelector(blockerSelector);

    if (!blocker) {
      return false;
    }

    restrictedForms.set(productForm, blocker.cloneNode(true));
    return true;
  }

  function restoreRestriction(productForm) {
    const blockerTemplate = restrictedForms.get(productForm);
    const buyButtons = productForm.querySelector('buy-buttons');

    if (!blockerTemplate || !buyButtons) {
      return;
    }

    if (!buyButtons.querySelector(blockerSelector)) {
      buyButtons.prepend(blockerTemplate.cloneNode(true));
    }

    buyButtons.querySelectorAll('button[type="submit"]').forEach(function (button) {
      button.remove();
    });
  }

  function inspectVipForms() {
    document.querySelectorAll(vipProductFormSelector).forEach(function (productForm) {
      if (!captureRestriction(productForm) && restrictedForms.has(productForm)) {
        restoreRestriction(productForm);
      }
    });
  }

  function handleVariantChange(event) {
    const formId = event.detail?.formId;
    const form = formId ? document.getElementById(formId) : null;
    const productForm = form?.closest(vipProductFormSelector);

    if (productForm && restrictedForms.has(productForm)) {
      restoreRestriction(productForm);
    }
  }

  function preventRestrictedSubmission(event) {
    const productForm = event.target.closest?.(vipProductFormSelector);

    if (!productForm || !restrictedForms.has(productForm)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    restoreRestriction(productForm);
  }

  function startRestrictionObserver() {
    inspectVipForms();

    new MutationObserver(inspectVipForms).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('variant:change', handleVariantChange);
  document.addEventListener('submit', preventRestrictedSubmission, true);
  document.addEventListener('shopify:section:load', inspectVipForms);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startRestrictionObserver, { once: true });
  } else {
    startRestrictionObserver();
  }
})();

(function setupCandyRackNbaShippingMessage() {
  const placeholderSelector = '#granite-nba-shipping-message';
  const productNbaCache = new Map();
  let refreshTimer = null;
  let refreshVersion = 0;
  let lastCartSignature = '';
  let lastCartContainsNba = null;
  let pendingCartSignature = '';

  function getShopifyRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function getOrCreatePlaceholder(drawer) {
    let placeholder = drawer.querySelector(placeholderSelector);
    const offers = drawer.querySelector('.candyrack-slider-cart-offers-wrapper');

    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.id = placeholderSelector.slice(1);
      placeholder.hidden = true;
      placeholder.dataset.graniteNbaShippingAuto = 'true';
    }

    /* Candy Rack places its custom footer after Checkout. Keep this message
       in the scrollable content, immediately before the upsell offers. */
    if (offers?.parentElement) {
      if (placeholder.parentElement !== offers.parentElement || placeholder.nextElementSibling !== offers) {
        offers.parentElement.insertBefore(placeholder, offers);
      }

      return placeholder;
    }

    const footer = drawer.querySelector('.candyrack-slider-cart-footer-wrapper');
    const subtotalSection = footer?.querySelector('.candyrack-slider-cart-footer-subtotal-wrapper')?.parentElement;

    if (footer && subtotalSection) {
      footer.insertBefore(placeholder, subtotalSection);
      return placeholder;
    }

    return placeholder.isConnected ? placeholder : null;
  }

  function updateLegacyShippingIcon(drawer) {
    const shippingBlock = drawer.querySelector('[futureblink-shipping-type="cart_drawer"]');
    const legacyIcon = shippingBlock?.nextElementSibling;

    if (!legacyIcon?.classList.contains('fs-icon')) {
      return;
    }

    const hasShippingContent = Boolean(
      shippingBlock.children.length || shippingBlock.textContent.trim()
    );

    if (hasShippingContent) {
      legacyIcon.style.removeProperty('display');
    } else {
      legacyIcon.style.setProperty('display', 'none', 'important');
    }
  }

  function setHostVisibility(placeholder, isVisible) {
    placeholder.hidden = !isVisible;

    const host = placeholder.parentElement;
    const hostOnlyContainsPlaceholder = host
      && host.children.length === 1
      && host.firstElementChild === placeholder;

    if (hostOnlyContainsPlaceholder) {
      host.hidden = !isVisible;
    }
  }

  function mountMessage(placeholder) {
    if (placeholder.dataset.graniteNbaShippingReady === 'true') {
      return;
    }

    const icon = document.createElement('span');
    icon.className = 'granite-nba-shipping-message__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg viewBox="0 0 32 32" fill="none" role="presentation"><path d="M3.5 7.5h16v15h-16zM19.5 12h4.2l4.8 5v5.5h-9z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M23.7 12v5h4.8" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="9" cy="23" r="2.7" fill="#fff" stroke="currentColor" stroke-width="1.8"/><circle cx="24" cy="23" r="2.7" fill="#fff" stroke="currentColor" stroke-width="1.8"/></svg>';

    const content = document.createElement('span');
    content.className = 'granite-nba-shipping-message__content';

    const heading = document.createElement('strong');
    heading.textContent = 'NBA items ship within 3 business days';

    const description = document.createElement('span');
    description.textContent = 'Fast turnaround on officially licensed NBA prints.';

    content.append(heading, description);
    placeholder.replaceChildren(icon, content);
    placeholder.classList.add('granite-nba-shipping-message');
    placeholder.setAttribute('role', 'status');
    placeholder.dataset.graniteNbaShippingReady = 'true';
  }

  function getCartProductHandles(drawer) {
    const handles = Array.from(drawer.querySelectorAll(
      '.candyrack-slider-cart-item-container a[href*="/products/"]'
    )).map(function (link) {
      try {
        const pathname = new URL(link.href, window.location.origin).pathname;
        const match = pathname.match(/\/products\/([^/?#]+)/);
        return match ? decodeURIComponent(match[1]) : '';
      } catch (error) {
        return '';
      }
    }).filter(Boolean);

    return Array.from(new Set(handles));
  }

  function getStoredNbaStatus(handle) {
    try {
      const storedValue = window.sessionStorage.getItem(`granite-nba-product:${handle}`);
      return storedValue === null ? null : storedValue === 'true';
    } catch (error) {
      return null;
    }
  }

  function storeNbaStatus(handle, isNba) {
    try {
      window.sessionStorage.setItem(`granite-nba-product:${handle}`, String(isNba));
    } catch (error) {
      // Storage can be unavailable in private browsing; in-memory caching still works.
    }
  }

  function seedServerRenderedNbaStatuses() {
    const cacheElement = document.getElementById('granite-cart-nba-product-cache');

    if (!cacheElement) {
      return;
    }

    try {
      const statuses = JSON.parse(cacheElement.textContent || '{}');

      Object.entries(statuses).forEach(function ([handle, isNba]) {
        const normalizedStatus = isNba === true;
        productNbaCache.set(handle, normalizedStatus);
        storeNbaStatus(handle, normalizedStatus);
      });
    } catch (error) {
      // Invalid or unavailable preload data falls back to the product endpoint.
    }
  }

  async function productHasNbaTag(handle) {
    if (!handle) {
      return false;
    }

    if (productNbaCache.has(handle)) {
      return productNbaCache.get(handle);
    }

    const storedStatus = getStoredNbaStatus(handle);

    if (storedStatus !== null) {
      productNbaCache.set(handle, storedStatus);
      return storedStatus;
    }

    const request = fetch(`${getShopifyRoot()}products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      cache: 'force-cache',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(`Unable to load product ${handle}`);
        }

        return response.json();
      })
      .then(function (product) {
        const tags = Array.isArray(product.tags)
          ? product.tags
          : String(product.tags || '').split(',');

        const isNba = tags.some(function (tag) {
          return String(tag).trim().toLowerCase() === 'nba';
        });

        productNbaCache.set(handle, isNba);
        storeNbaStatus(handle, isNba);
        return isNba;
      })
      .catch(function () {
        productNbaCache.delete(handle);
        return false;
      });

    productNbaCache.set(handle, request);
    return request;
  }

  async function refreshMessage() {
    refreshTimer = null;

    const drawer = document.getElementById('candyrack-slider-cart');
    const placeholder = drawer ? getOrCreatePlaceholder(drawer) : null;

    if (!placeholder) {
      return;
    }

    updateLegacyShippingIcon(drawer);

    const uniqueHandles = getCartProductHandles(drawer);

    if (!uniqueHandles.length) {
      return;
    }

    const cartSignature = uniqueHandles.slice().sort().join('|');

    if (cartSignature === lastCartSignature && lastCartContainsNba !== null) {
      if (lastCartContainsNba) {
        mountMessage(placeholder);
      }

      setHostVisibility(placeholder, lastCartContainsNba);
      return;
    }

    if (cartSignature === pendingCartSignature) {
      return;
    }

    const currentVersion = ++refreshVersion;
    pendingCartSignature = cartSignature;

    if (cartSignature !== lastCartSignature) {
      setHostVisibility(placeholder, false);
    }

    try {
      const results = await Promise.all(uniqueHandles.map(productHasNbaTag));

      if (currentVersion !== refreshVersion) {
        return;
      }

      if (!placeholder.isConnected) {
        pendingCartSignature = '';
        scheduleRefresh();
        return;
      }

      const containsNbaProduct = results.some(Boolean);
      lastCartSignature = cartSignature;
      lastCartContainsNba = containsNbaProduct;
      pendingCartSignature = '';

      if (containsNbaProduct) {
        mountMessage(placeholder);
      }

      setHostVisibility(placeholder, containsNbaProduct);
    } catch (error) {
      pendingCartSignature = '';

      if (currentVersion === refreshVersion && placeholder.isConnected) {
        setHostVisibility(placeholder, false);
      }
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshMessage, 40);
  }

  function startObserver() {
    seedServerRenderedNbaStatuses();
    scheduleRefresh();

    new MutationObserver(function (mutations) {
      const drawerChanged = mutations.some(function (mutation) {
        return mutation.target.closest?.('#candyrack-slider-cart')
          || Array.from(mutation.addedNodes).some(function (node) {
            return node.nodeType === Node.ELEMENT_NODE
              && (node.id === 'candyrack-slider-cart' || node.querySelector?.('#candyrack-slider-cart'));
          });
      });

      if (drawerChanged) {
        scheduleRefresh();
      }
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
